import React, { useEffect, useRef, useState } from "react";

import HttpManager from "../../services/HttpManager";
import { cursoCorto } from "../../utils/cursoCorto";

/*
	2x1: qué curso se regala. Las matrículas de la misma persona («mías») y, si es de otra, el buscador (GET payments/_twoForOne/_options).
	Al elegir, el servidor revisa el par (regalado + base) con GET payments/_twoForOne y sus motivos se devuelven en `onIssues`.
	Lo usan el panel de Caja y la Solicitud de Promoción.
*/

const http = HttpManager.getInstance();

export interface CursoRegalado { enrollmentId: number; studentId: number | null; name: string; courseName?: string; scheduleName?: string }

interface Props {
	campusId: number;
	/** Quien paga (la base). */
	studentId: number;
	/** La matrícula que paga: no se ofrece como regalo. */
	baseEnrollmentId: number;
	/** El curso regalado elegido (o el que trajo el ticket, aunque no salga en la lista: `pinned`). */
	giftEnrollmentId: number | null;
	pinned?: CursoRegalado | null;
	disabled?: boolean;
	serverError: (e: any) => string;
	onPick: (v: CursoRegalado) => void;
	/** Lo que dice el servidor del par elegido (vacío = bien); null mientras revisa. */
	onIssues: (issues: string[] | null) => void;
	onError?: (text: string) => void;
}

const CursoRegalado2x1: React.FC<Props> = ({ campusId, studentId, baseEnrollmentId, giftEnrollmentId, pinned, disabled, serverError, onPick, onIssues, onError }) => {
	const [mine, setMine] = useState<any[] | null>(null);
	const [q, setQ] = useState("");
	const [found, setFound] = useState<any[]>([]);
	const timer = useRef<any>(null);

	useEffect(() => {
		let dead = false;
		http.paymentService.twoForOneOptions(campusId, studentId, "").then((r: any) => { if (!dead) setMine(r.data?.mine || []); }).catch((e: any) => { if (!dead) onError?.(serverError(e)); });
		return () => { dead = true; clearTimeout(timer.current); };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campusId, studentId]);

	// El servidor revisa el par (regalado + base) antes de registrar; sus motivos se ven aquí.
	useEffect(() => {
		if (!giftEnrollmentId) return;
		let dead = false;
		onIssues(null);
		http.paymentService.twoForOnePreview(campusId, giftEnrollmentId, baseEnrollmentId).then((r: any) => {
			if (!dead) onIssues((r.data?.issues || []).map((x: any) => String(x)));
		}).catch((e: any) => { if (!dead) onIssues([serverError(e)]); });
		return () => { dead = true; };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [giftEnrollmentId, baseEnrollmentId, campusId]);

	const buscar = (v: string) => {
		setQ(v);
		clearTimeout(timer.current);
		if (v.trim().length < 2) { setFound([]); return; }
		timer.current = setTimeout(() => {
			http.paymentService.twoForOneOptions(campusId, studentId, v.trim()).then((r: any) => setFound(r.data?.results || [])).catch((e: any) => onError?.(serverError(e)));
		}, 300);
	};

	const gifts: any[] = [...(mine || []), ...found.filter((r) => !(mine || []).some((m) => m.enrollmentId === r.enrollmentId))].filter((v) => v.enrollmentId !== baseEnrollmentId);
	if (pinned && pinned.enrollmentId && !gifts.some((v) => v.enrollmentId === pinned.enrollmentId)) {
		gifts.unshift({ enrollmentId: pinned.enrollmentId, studentId: pinned.studentId, name: pinned.name || "Curso Regalado", courseName: pinned.courseName || "", scheduleName: pinned.scheduleName || "" });
	}
	return (
		<div style={{ marginTop: 8 }}>
			<div style={{ fontWeight: 700 }}>Curso Regalado</div>
			{mine === null ? <div style={{ color: "var(--wa-apagado)" }}>Cargando…</div> : gifts.map((v) => {
				const on = giftEnrollmentId === v.enrollmentId;
				return (
					<label key={"g" + v.enrollmentId} style={{ position: "static", display: "flex", gap: 8, alignItems: "flex-start", padding: "6px 8px", margin: "3px 0", cursor: "pointer",
						border: "1px solid " + (on ? "var(--wa-acento)" : "var(--wa-filo)"), borderRadius: 6, background: on ? "var(--wa-superficie)" : "transparent", whiteSpace: "normal", overflow: "visible" }}>
						<input type="radio" style={{ marginTop: 3 }} checked={on} disabled={disabled}
							onChange={() => onPick({ enrollmentId: v.enrollmentId, studentId: Number(v.studentId) || studentId, name: v.name, courseName: v.courseName || "", scheduleName: v.scheduleName || "" })} />
						<span style={{ minWidth: 0 }}><b>{v.name}</b>
							{v.courseName || v.scheduleName ? <div style={{ color: "var(--wa-apagado)", fontSize: 12 }}>{[v.courseName ? cursoCorto(v.courseName) : "", v.scheduleName || ""].filter(Boolean).join(" ")}</div> : null}</span>
					</label>
				);
			})}
			<input className="form-control form-control-sm" style={{ maxWidth: 420, marginTop: 6, fontSize: 16 }} value={q} disabled={disabled} onChange={(e) => buscar(e.target.value)}
				placeholder="Buscar Otra Persona" />
		</div>
	);
};

export default CursoRegalado2x1;
